import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IUserIdentity } from '../interfaces/IUserIdentity';
import { logout } from '../action/logout-action';

const initialState :IUserIdentity[]= window.sessionStorage.getItem('userIdentity') ? JSON.parse(window.sessionStorage.getItem("userIdentity")) : []

export const SwitchUserRole = createSlice({
  name: 'userRole',
  initialState,
  extraReducers: (builder) => builder.addCase(logout, () => []),
  reducers: { 
    StoreUserIdentity: (state=initialState, action: PayloadAction<IUserIdentity>) => {  
          let Msg: IUserIdentity={
            theme: action.payload.theme,
            usertype: action.payload.usertype ||"",
            userTimezone: action.payload.userTimezone
          }
          return [Msg];
    },
  },
})

export const { StoreUserIdentity } = SwitchUserRole.actions
export default SwitchUserRole.reducer